import * as yup from "yup";

export const myPasswordFormSchema = yup.object({
  currentPassword: yup.string().required("Текущата парола е задължителна"),
  newPassword: yup
    .string()
    .required("Новата парола е задължителна")
    .min(6, "Паролата трябва да е поне 6 символа"),
  confirmNewPassword: yup
    .string()
    .required("Потвърждението е задължително")
    .oneOf([yup.ref("newPassword")], "Паролите не съвпадат"),
});

export type IMyPasswordFormModel = yup.InferType<typeof myPasswordFormSchema>;

export const myPasswordFormDefaultValues: IMyPasswordFormModel = {
  currentPassword: "",
  newPassword: "",
  confirmNewPassword: "",
};
